import { check } from "./check.js";
export default function parseCompositeCheckDigit(checkDigit, ...sources) {
    const source = sources.join('');
    check(source, checkDigit);
    return checkDigit;
}
//# sourceMappingURL=parseCompositeCheckDigit.js.map